/**
 * Pure helpers for the CRM quote-draft editor / `crm_prefill_quote` frontend action.
 * No React/DOM deps so the prefill contract is cheaply unit-testable.
 */

export interface DraftItem {
  product_name: string;
  quantity: number;
  unit_price: number;
  discount_percent: number;
}

export function lineTotal(it: DraftItem): number {
  return it.quantity * it.unit_price * (1 - (it.discount_percent || 0) / 100);
}

/**
 * Normalize agent-supplied quote items into valid DraftItems.
 * Coerces numbers, clamps discount 0-100, drops rows missing a name or with qty <= 0.
 */
export function normalizeQuoteItems(raw: unknown): DraftItem[] {
  const arr = Array.isArray(raw) ? (raw as Record<string, unknown>[]) : [];
  return arr
    .map((it) => ({
      product_name: String(it?.product_name ?? '').slice(0, 200),
      quantity: Number(it?.quantity) || 0,
      unit_price: Number(it?.unit_price) || 0,
      discount_percent: Math.min(100, Math.max(0, Number(it?.discount_percent) || 0)),
    }))
    .filter((it) => it.product_name.trim() !== '' && it.quantity > 0);
}
